module.exports = __webpack_public_path__ + "img/c.b38f4765.jpg";